import { IEmployee } from "src/app/employee/employee";
import { IDayReportingObject } from "./day-reporting-object";
import { IBaseSearchRequest } from "src/app/core/models/base";

export interface IAbsenceGroup {
    id:                  string;
    title:               string;
    dateFrom:            Date;
    isHalfDayStart: boolean;
    dateTo:              Date;
    isHalfDayEnd: boolean;
    absenceType:         AbsenceType;
    absenceState:       AbsenceState;
    confirmedById:       string;
    confirmedBy:       IEmployee;
    confirmedOn:         Date;
    signedById:          string;
    signedBy:          IEmployee;
    signedOn:            Date;
    dayReportingObjects: IDayReportingObject[];
    employeeId:          string;
    employee: IEmployee;
    absences : IAbsence[];
    durationAsDays?: number;
}

// Planning view of an absence (scheduler): what every planner may see. When isRedacted is set,
// the absentee is outside the viewer's supervisor reach - absenceType is Unknown and title empty.
export interface IAbsencePlanning {
    id:             string;
    employeeId:     string;
    employee:       IEmployee;
    dateFrom:       Date;
    isHalfDayStart: boolean;
    dateTo:         Date;
    isHalfDayEnd:   boolean;
    absenceState:   AbsenceState;
    absenceType:    AbsenceType;
    title?:         string;
    isRedacted?:    boolean;
}

export interface IAbsence {
    id:                  string;
    date:            Date;
    isHalfDayStart: boolean;
    isHalfDayEnd: boolean;
    absenceGroup?: IAbsenceGroup;
}

export interface ICreateAbsenceGroupApplicationRequest {
    title:       string;
    dateFrom:    string;
    isHalfDayStart:    boolean;
    dateTo:      string;
    isHalfDayEnd:      boolean;
    absenceType: number;
}

export interface ICreateAbsenceGroupRequest extends ICreateAbsenceGroupApplicationRequest {
    employeeId:  string;
}

export interface IUpdateAbsenceGroupStateRequest {
    absenceGroupId: string;
    absenceState: AbsenceState;
}

export interface ISearchAbsenceGroupsRequest extends IBaseSearchRequest{
    employeeId?:  string;
    start?: Date;
    end?: Date;
}

export enum AbsenceType
{
    // Unknown = 0,
    Vacation = 1,
    PaidLeave = 2,
    UnpaidLeave = 3,
    Compensation = 4,
    // PreWorked = 5,
    // Holiday = 6,
    Military = 7,
    Sick = 8,
    Accident = 9,
    Education = 10,
    OvertimeCompensation = 11,
}

export enum AbsenceState {
    Open = 0,
    Accepted = 10,
    Declined = 20
}